import { concurUnlinkError } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

const unlinkConcurError = () => addMessage(concurUnlinkError);
export default unlinkConcurError;
